import { render, staticRenderFns } from "./people-card.vue?vue&type=template&id=1991a3fa&scoped=true"
import script from "./people-card.vue?vue&type=script&lang=js"
export * from "./people-card.vue?vue&type=script&lang=js"
import style0 from "./people-card.vue?vue&type=style&index=0&id=1991a3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1991a3fa",
  null
  
)

export default component.exports